import {TextField} from '@mui/material';
import React from 'react';
import {EZPRSelect} from '../../utils/EZPRSelect.jsx';
import {PRFileUpload} from '../../utils/PRFileUpload.jsx';
import PropTypes from 'prop-types';
import {COUNTRIES} from '../../utils/CountryData';
import {requestStores} from '../../../ListOfPREditors.brick.jsx';
import {Attachment} from '../../../../models/attachments_info/Attachment';
import {AttachmentsTable} from '../../attachments_comments/AttachmentsTable.jsx';
import {LimitedLengthTextfield} from '../../utils/LimitedLengthTextfield.jsx';
import {BrickContext} from 'olympe';

/**
 * @param {OneTimeVendorForm.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function OneTimeVendorForm(props) {
    const useRequestStore = requestStores.get(props.prTag);

    const createMainAttachment = useRequestStore((state) => state.createMainAttachment);

    const handleOTVNameChange = (newName) => {
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                name: newName,
            };
        });
    };
    const handleOTVName2Change = (newName) => {
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                name2: newName,
            };
        });
    };

    const handleOTVAddressStreetChange = (event) => {
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                street: event.target.value,
            };
        });
    };

    const handleOTVAddressHouseNrChange = (event) => {
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                houseNumber: event.target.value,
            };
        });
    };

    const handleOTVAddressPostalCodeChange = (event) => {
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                postalCode: event.target.value,
            };
        });
    };

    const handleOTVAddressCityChange = (event) => {
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                city: event.target.value,
            };
        });
    };

    const handleOTVAddressStateChange = (event) => {
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                state: event.target.value,
            };
        });
    };

    const handleOTVAddressCountryChange = (newValue) => {
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                country: newValue,
            };
        });
    };

    const handleOTVPhoneNumberChange = (event) => {
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                phoneNumber: event.target.value,
            };
        });
    };

    const handleUploadFile = (attachment) => {
        createMainAttachment(new Attachment(attachment.tag, '', attachment.user, attachment.date, attachment.name, attachment.userId));
        props.setOTVInfo((prevState) => {
            return {
                ...prevState,
                attachmentUploaded: true,
            };
        });
    };

    return (
        <>
            <div className={'pr-editor-search-supplier-popup-one-time-vendor-form'}>
                <div className={'pr-editor-search-supplier-required'}>Supplier name: </div>
                <LimitedLengthTextfield
                    variant={'standard'}
                    value={props.OTVInfo.name}
                    onChange={handleOTVNameChange}
                    disabled={props.disableAll}
                    maxLength={40}/>
                <div>Supplier name 2: </div>
                <LimitedLengthTextfield
                    variant={'standard'}
                    value={props.OTVInfo.name2}
                    onChange={handleOTVName2Change}
                    disabled={props.disableAll}
                    maxLength={40}/>
                <div className={'pr-editor-search-supplier-required'}>House no:</div>
                <div className={'pr-editor-search-supplier-popup-one-time-vendor-form-double-field'}>
                    <TextField
                        size={'small'}
                        variant={'standard'}
                        value={props.OTVInfo.houseNumber}
                        disabled={props.disableAll}
                        onChange={handleOTVAddressHouseNrChange}/>
                    <div className={'pr-editor-search-supplier-required'}>Street:</div>
                    <TextField
                        size={'small'}
                        variant={'standard'}
                        value={props.OTVInfo.street}
                        disabled={props.disableAll}
                        onChange={handleOTVAddressStreetChange}
                        sx={{flex: 1}} />
                </div>
                <div className={'pr-editor-search-supplier-required'}>Postal Code:</div>
                <div className={'pr-editor-search-supplier-popup-one-time-vendor-form-double-field'}>
                    <TextField
                        size={'small'}
                        variant={'standard'}
                        value={props.OTVInfo.postalCode}
                        disabled={props.disableAll}
                        onChange={handleOTVAddressPostalCodeChange}/>
                    <div className={'pr-editor-search-supplier-required'}>City:</div>
                    <TextField
                        size={'small'}
                        variant={'standard'}
                        value={props.OTVInfo.city}
                        disabled={props.disableAll}
                        onChange={handleOTVAddressCityChange}
                        sx={{flex: 1}} />
                </div>

                <div className={'pr-editor-search-supplier-required'}>State/Province/Area:</div>
                <div className={'pr-editor-search-supplier-popup-one-time-vendor-form-double-field'}>
                    <TextField
                        size={'small'}
                        variant={'standard'}
                        value={props.OTVInfo.state}
                        disabled={props.disableAll}
                        onChange={handleOTVAddressStateChange}/>
                    <div className={'pr-editor-search-supplier-required'}>Country:</div>
                    <EZPRSelect
                        options={COUNTRIES.map((c) => c.name)}
                        value={props.OTVInfo.country}
                        readOnly={props.disableAll}
                        onChange={handleOTVAddressCountryChange}
                        valueFromSelectionOnly={true}
                    />
                </div>

                <div>Phone number:</div>
                <TextField
                    size={'small'}
                    variant={'standard'}
                    value={props.OTVInfo.phoneNumber}
                    disabled={props.disableAll}
                    onChange={handleOTVPhoneNumberChange}/>

                <div className={'pr-editor-search-supplier-required'} style={{whiteSpace: 'pre'}}>Attachments {props.showCollectiveMedicalVendor ? '\n(Request/Acceptance letters + \nBanking details such as IBAN, W9 \nor others as per country requirements)' : '(IBAN, W9, ETC.)'}</div>
                <PRFileUpload
                    onFileUploaded={(att) => {
                        handleUploadFile(att);
                        props.onChange();
                    }}
                    persistFiles={true}
                    disabled={props.disableAll}
                    triggerClearFileName={props.triggerClearFileName}/>
            </div>
            <AttachmentsTable
                prTag={props.prTag}
                context={props.context}
                attachmentsType='main'
                disabled={props.disableAll}
                from={props.showCollectiveMedicalVendor ? 'cmvPopup' : 'otvPopup'}
                onChange={props.onChange}
            />
        </>
    );
}

OneTimeVendorForm.propTypes = {
    prTag: PropTypes.string.isRequired,
    OTVInfo: PropTypes.object.isRequired,
    setOTVInfo: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    showCollectiveMedicalVendor: PropTypes.bool,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    triggerClearFileName: PropTypes.bool,
    disableAll: PropTypes.bool,
};

OneTimeVendorForm.defaultProps = {
    disableAll: false,
};
